



















































import Vue from "vue";
import GridView from "../../components/GridView.vue";
import { GridRow, GridData } from "../../components/GridView.vue";
import GridViewSmall from "../../components/GridViewSmall.vue";
import get from "lodash-es/get";
import sumBy from "lodash-es/sumBy";
import isEmpty from "lodash-es/isEmpty";
import orderBy from "lodash-es/orderBy";

import {
  WidgetQueryType,
  WidgetDataOpenViewModel,
  WidgetDataConversieViewModel
} from "./Dashboard.vue";

export default Vue.extend({
  props: {
    queryType: {
      type: [Number],
      required: true,
      default: 0
    },
    xsonly: {
      type: Boolean,
      default: false
    },
    smonly: {
      type: Boolean,
      default: false
    },
    gridTitle: {
      required: true,
      type: String,
      default: ""
    },
    widgetDetailsData: {
      required: true,
      default: () => {
        return [] as WidgetDataOpenViewModel[] | WidgetDataConversieViewModel[];
      }
    }
  },

  computed: {
    showOpenResults(): boolean {
      return (
        this.queryType === WidgetQueryType.WidgetSalesOpen ||
        this.queryType === WidgetQueryType.WidgetAftersalesOpen
      );
    },
    showConversieResults(): boolean {
      return (
        this.queryType === WidgetQueryType.WidgetSalesConversie ||
        this.queryType === WidgetQueryType.WidgetAftersalesConversie
      );
    },
    columnCols(): any[] {
      if (this.showOpenResults) return [3, 2, 2, 2, 3];
      if (this.showConversieResults) return [3, 1, 1, 1, 1, 2, 1, 1, 1];
      return [12];
    },
    showNoResults(): boolean {
      return isEmpty(this.detailDataRows);
    },
    showResults(): boolean {
      return !this.xsonly && !this.smonly && !isEmpty(this.detailDataRows);
    },
    showXsResults(): boolean {
      return this.xsonly && !isEmpty(this.detailDataRows);
    },
    showSmResults(): boolean {
      return this.smonly && !isEmpty(this.detailDataRows);
    },

    widgetHeaders(): any {
      if (this.showOpenResults) {
        return {
          Fields: [
            this.gridTitle,
            `${this.$i18n.t("open")}`,
            `${this.$i18n.t("new")}`,
            `${this.$i18n.t("inbehandeling")}`,
            `${this.$i18n.t("verstreken")}`
          ]
        } as GridRow;
      } else if (this.showConversieResults) {
        return {
          Fields: [
            this.gridTitle,
            `${this.$i18n.t("afgerond")}`,
            `${this.$i18n.t("succesvol")}`,
            `${this.$i18n.t("gemist")}`,
            `${this.$i18n.t("verwijderd")}`,
            `${this.$i18n.t("conversieratio")}`,
            `${this.$i18n.t("orders")}`,
            `${this.$i18n.t("orderratio")}`,
            `${this.$i18n.t("deadlinegehaald")}`
          ]
        } as GridRow;
      }
    },
    widgetHeadersSmall(): any {
      if (this.showOpenResults) {
        return {
          Fields: [
            this.gridTitle,
            `${this.$i18n.t("open")}`,
            `${this.$i18n.t("new")}`,
            `${this.$i18n.t("inbehandeling")}`,
            `${this.$i18n.t("verstreken")}`
          ]
        } as GridRow;
      } else if (this.showConversieResults) {
        return {
          Fields: [
            this.gridTitle,
            `${this.$i18n.t("afgerond")}`,
            `${this.$i18n.t("succesvol")}`,
            `${this.$i18n.t("gemist")}`,
            `${this.$i18n.t("verwijderd")}`,
            `${this.$i18n.t("conversieratiosmall")}`,
            `${this.$i18n.t("orders")}`,
            `${this.$i18n.t("orderratiosmall")}`,
            `${this.$i18n.t("deadlinegehaaldsmall")}`
          ]
        } as GridRow;
      }
    },
    detailDataRows(): any[] {
      if (isEmpty(this.widgetDetailsData)) return [];

      return orderBy(this.widgetDetailsData, ["Titel"], ["asc"]);
    },

    widgetGridData(): GridData {
      let data = {
        Rows: [] as GridRow[]
      };
      if (isEmpty(this.detailDataRows)) return data;

      let rows = this.detailDataRows.map(w => this.createGridRow(w));
      if (!isEmpty(rows)) data.Rows = rows as GridRow[];
      return data;
    },
    widgetGridTotals(): GridRow | null {
      let totalrow = { Fields: [] } as GridRow;
      if (!this.queryType || isEmpty(this.detailDataRows)) return totalrow;

      if (this.showOpenResults) {
        return this.createGridRow({
          Id: "tot",
          Titel: `${this.$i18n.t("total")}`,
          Open: sumBy(this.detailDataRows, "Open"),
          Nieuw: sumBy(this.detailDataRows, "Nieuw"),
          Lopend: sumBy(this.detailDataRows, "Lopend"),
          DLVerstreken: sumBy(this.detailDataRows, "DLVerstreken")
        });
      } else if (this.showConversieResults) {
        let sumSuccess = sumBy(this.detailDataRows, "Succes");
        let sumGemist = sumBy(this.detailDataRows, "Gemist");
        let order = sumBy(this.detailDataRows, "Order");
        let afgerond = sumBy(this.detailDataRows, "Afgerond");
        let gehaald = sumBy(this.detailDataRows, "DLGehaald");
        let heeftDLEnAfgerond = sumBy(this.detailDataRows, "HeeftDLEnAfgerond");

        return this.createGridRow({
          Id: "tot",
          Titel: `${this.$i18n.t("total")}`,
          Afgerond: afgerond,
          Succes: sumSuccess,
          Gemist: sumGemist,
          Verwijderd: sumBy(this.detailDataRows, "Verwijderd"),
          Conversie:
            Math.round(
              sumSuccess + sumGemist === 0 ? 0.0 : (100.0 * sumSuccess) / (sumSuccess + sumGemist)
            ) + "%",
          Order: order,
          OrderRatio:
            Math.round(
              sumSuccess + sumGemist === 0 ? 0.0 : (100.0 * order) / (sumSuccess + sumGemist)
            ) + "%",
          DLRatio:
            Math.round(
              heeftDLEnAfgerond === 0 ? 100.0 : (100.0 * gehaald) / (heeftDLEnAfgerond * 1.0)
            ) + "%"
        });
      }

      return null;
    }
  },

  methods: {
    createGridRow(w: any): GridRow | null {
      if (this.showOpenResults) {
        return {
          RowId: w.Id,
          Fields: [w.Titel, w.Open, w.Nieuw, w.Lopend, w.DLVerstreken]
        };
      } else if (this.showConversieResults) {
        return {
          RowId: w.Id,
          Fields: [
            w.Titel,
            w.Afgerond,
            w.Succes,
            w.Gemist,
            w.Verwijderd,
            w.Conversie,
            w.Order,
            w.OrderRatio,
            w.DLRatio
          ]
        };
      }
      return null;
    },
    onRowDeselected(): void {
      this.$emit("row-deselected");
    },
    onRowSelected(data: any): void {
      this.$emit("row-selected", {
        IsTotalRow: data.IsTotalRow,
        Id: data.Id
      });
    }
  },

  components: {
    GridView,
    GridViewSmall
  }
});
